function markdownFormater(markdown) {
  const pipeRegex = /&#124;/g;
  return markdown.replace(pipeRegex, '|');
}

export default markdownFormater;
